import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IconComponent } from 'src/app/core/components/icon/icon.component';
import { ShopifyMediaItemComponent } from '../shopify-media-item/shopify-media-item.component';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { Product } from 'src/app/shop/models/product.model';
import { CurrencyPipe } from '@angular/common';
import { ProductPreview } from 'src/app/content-blocks/models';

@Component({
  selector: 'app-product-link-card',
  imports: [IconComponent, RouterLink, ShopifyMediaItemComponent, FromDictionaryPipe, CurrencyPipe],
  templateUrl: './product-link-card.component.html',
  styleUrl: './product-link-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductLinkCardComponent {
  product = input<Product>();
  productPreview = input<ProductPreview>();
}
